import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ModalGastos } from './ModalGastos';
import { ApiService } from '../ApiService';

export const ModalDetalleCaja = ({ isOpen, onClose, rowData, key_branch, updated_list }) => {
  if (!isOpen) return null;
  
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevenir recarga automática del formulario
    const formulario = e.target;
    const ckeck_radio = formulario.elements['formaPago'];
    let value_Check;

    for (let i = 0; i < ckeck_radio.length; i++) {
        if (ckeck_radio[i].checked) {
            value_Check = ckeck_radio[i].value;
            break;
        }
    }

    if (!value_Check) 
        return toast.error('Debe seleccionar una forma de pago', { position: 'top-right' });

    const url = `api/company/${rowData.type == 1 ? 'sale' : (rowData.type == 2 ? 'expense' : 'purchase')}/set-payment?key_branch=${key_branch}`;

    const options = {
        method: 'PUT',
        body: JSON.stringify({
            key_data: rowData.key_data,
            tpay: String(value_Check).toLowerCase(),
        }),
    };

    const fetch_request = await ApiService.fetchData(url, options);

    if (!fetch_request) return toast.error('Error en la solicitud', { position: 'top-right' });

    updated_list();
    onClose();
};

  return (
    <div className="modal-overlay-caja">
      <div className="modal-container-caja">
        <div className="modal-header-old">
          <h2 className="modal-title">Forma de pago</h2>
          <button className="close-modal-btn-caja" onClick={onClose}>
            ✖
          </button>
        </div>
        <div className="modal-body-caja" style={{ marginTop: '5px' }}>
          <table className="modal-detail-table">
            <tbody>
              <tr>
                <td>Código:</td>
                <td>{rowData?.code}</td>
              </tr>
              <tr>
                <td>Nombre:</td>
                <td>{rowData?.detail}</td>
              </tr>
              <tr>
                <td>Cantidad:</td>
                <td>{rowData?.qp || 'N/A'}</td>
              </tr>
              <tr>
                <td>Precio Unidad:</td>
                <td>Bs. {rowData?.purchase_price}</td>
              </tr>
              <tr>
                <td>Descuento:</td>
                <td>Bs. {rowData?.discount || '0'}</td>
              </tr>
              <tr>
                <td>Total:</td>
                <td>Bs. {(parseFloat(rowData.purchase_price) * parseInt(rowData.qp) - parseFloat(rowData?.discount || '0')).toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <form onSubmit={handleSubmit}>
            <div className="form-group pay-title" style={{ marginTop: '15px' }}>
              <div>
                <span>Forma de pago:  <span style={{ color: 'red' }}>*</span> </span>
              </div>
            </div>

            <div className="form-group total-payment-caja">
              <div className="payment-options-caja">
                <label className={'payment-option-caja'}>
                  <input
                    type="radio"
                    name="formaPago"
                    value="Efectivo"
                  />
                  <span>Efectivo</span>
                </label>
                <label className="payment-option-caja">
                  <input
                    type="radio"
                    name="formaPago"
                    value="QR"
                  />
                  <span>QR</span>
                </label>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="cancel-button-product" onClick={onClose}>
                Cancelar
              </button>
              <button type="submit" className="save-button">
                Guardar
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};
